<ion-header class="ion-no-border">
  <ion-toolbar color="primary">
    <ion-title>Cancella appuntamenti</ion-title>

    <ion-buttons slot="end">
      <ion-button (click)="onClose()">
        <ion-icon slot="icon-only" [src]="'close' | getIcon"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid class="ion-margin">
    <ion-row>
      <ion-col>
        <ion-text>
          <h3>Spunta gli appuntamenti che vuoi disdire per questo paziente</h3>
        </ion-text>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="12" *ngFor="let appointment of appointments; let i = index" class="ion-no-padding">
        <ion-item lines="none">
          <ion-checkbox checked="false" slot="start" color="secondary" [(ngModel)]="appointment.checked"
                        [value]="appointment.medicalService.description">
          </ion-checkbox>
          <ion-label>{{appointment.medicalService.description}}</ion-label>

        </ion-item>
      </ion-col>
    </ion-row>

  </ion-grid>
</ion-content>

<ion-footer class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button color="danger" (click)="onClose()">Annulla</ion-button>

      <ion-button color="primary" (click)="cancellaAppuntamenti()">
        <ng-container *ngIf="!loading">
          <span>Salva</span>
          <ion-icon slot="end" [src]="'content-save' | getIcon"></ion-icon>
        </ng-container>
        <ion-spinner slot="end" *ngIf="loading" color="secondary"></ion-spinner>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>